import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import SectionHeading from "~/client/pages/DemoRecipePage/SectionHeading";
import { Ingredient, IngredientsList, Section } from "./styled";
const IngredientsPanel = ({ ingredients, stepIngredients }) => {
    const ids = new Set(stepIngredients.map((value) => value.id));
    return (_jsxs(Section, { children: [_jsx(SectionHeading, { children: "Ingredients" }), _jsx(IngredientsList, { children: ingredients.map((ingredient, i) => (_jsxs(Ingredient, { "$isActive": ids.has(ingredient.id), children: [ingredient.quantity, " ", ingredient.unit, " ", ingredient.ingredient] }, i))) })] }));
};
export default IngredientsPanel;
